module.exports = __webpack_public_path__ + "static/media/Light_payment.3907ecb4.svg";